<template>
  <div class="about-us">
    <img class="logo" src="/img/background/screen/aboutUs-logo.png" alt="">
    <h3 class="title">上海能誉科技股份有限公司</h3>
    <div class="describe">
      <p class="con-text">
        本系统为上海能誉科技股份有限公司开发的线上竞价系统
      </p>
    </div>
    <p class="con-text">{{ about }}</p>

    <p class="con-text2"><span>&gt;&gt;&gt;</span>智能·集成·创新<span>&lt;&lt;&lt;</span></p>

    <p class="address"><a href="http://www.enercomn.com">www.enercomn.com</a></p>

    <p class="tel">24小时全国服务热线：18016418322</p>

    <div class="erweima">
      <img src="/img/background/screen/aboutUs-erweima.png" alt="">
      <p class="er-text">扫码关注能誉科技微信公众号</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    about: String
  },
}
</script>

<style lang="scss">
.el-dialog__body {
  .about-us {
    text-align: center;
    padding-top: 13px;
    padding-bottom: 82px;
    position: relative;
    .describe {
      display: flex;
      justify-content: center;
      margin-top: 25px;
      .con-text {
        width: 430px;
        font-size: 22px !important;
        color: #fff !important;
      }
    }
    .logo {
      width: 18.9%;
    }

    .title {
      font-size: 50px;
      margin-top: 35px;
      line-height: 1;
      color: #00a0e9;
    }
    .con-text {
      font-size: 22px !important;
      color: #fff !important;
    }
    .arrow {
      text-align: center;
      display: flex;
      justify-content: center;
    }

    .con-text2 {
      margin-top: 50px;
      text-align: center;
      font-size: 30px !important;
      color: #fff !important;
      span {
        margin: 0 2%;
      }
    }

    .address {
      a {
        color: #168cf7;
        font-weight: 400;
        font-size: 24px;
        transition: 0.3s;

        &:hover {
          color: #6eb2f1;
        }
      }
    }

    .tel {
      font-size: 14px !important;
      color: #fff !important;
      margin-bottom: 0;
    }

    .erweima {
      position: absolute;
      right: 80px;
      bottom: 18.3%;
      height: 25%;
      width: 20%;

      img {
        width: 120px;
        height: 120px;
      }

      p.er-text {
        @media screen and(max-width: 1280px) {
          font-size: 12px !important;
        }
        margin-top: 5px;
        font-size: 14px !important;
        color: #fff !important;
        white-space: nowrap;
      }
    }
  }
}
</style>